/** Commandes de la boutique en ligne (service `boutique`, décision n° 9). */
export const ETATS_COMMANDE = [
    'en_paiement',
    'payee',
    'expiree',
    'abandonnee',
    'a_rembourser',
    'remboursee',
    'annulee',
];
export const MOTIFS_COMMANDE = [
    'oeuvre_indisponible',
    'montant_divergent',
    'module_coupe',
    'session_impossible',
    'remboursement_demande',
];
export const RAISONS_NON_VENDABLE = [
    'hors_ligne',
    'sans_prix',
    'devise',
    'edition_au_compteur',
    'sans_exemplaire',
    'indisponible',
];
/** Stripe exige au moins trente minutes. */
export const DUREE_SESSION_PAIEMENT_MS = 31 * 60_000;
/** La réservation survit cinq minutes à la session : un webhook en retard trouve encore l'œuvre tenue. */
export const MARGE_RESERVATION_MS = 5 * 60_000;
//# sourceMappingURL=boutique.js.map